import axios from "axios";
import { config } from "../../../config/config";
import { LoginType } from "../../containers/auth/login/LoginModel";
import { SignUpType } from "../../containers/auth/signUp/SignUpModel";

// type LoginDataType = {
//   nik: number;
//   password: string;
// };

type ForgotPasswordBody = {
  nik: string;
  email: string;
};

type ResetPasswordBody = {
  newPassword: string;
  confirmNewPassword: string;
};

export const API_URL =
  config.SERVER_ENV === "staging"
    ? config.API_URL_STAGING
    : config.API_URL_PROD;
export const LOGIN_URL = `${API_URL}/authentications/member`;
export const SIGH_UP_URL = `${API_URL}/member`;
export const FORGOT_PASSWORD_URL = `${API_URL}/authentications/forgot-password`;
export const RESET_PASSWORD_URL = `${API_URL}/authentications/reset-password`;

export class AuthAPI {
  public static LoginApi(loginData: LoginType) {
    return axios.post(LOGIN_URL, {
      nik: loginData.nik,
      password: loginData.password,
    });
  }

  public static SignUpAPI(signUpData: SignUpType) {
    return axios.post(SIGH_UP_URL, {
      nik: signUpData.nik,
      name: signUpData.name,
      phoneNo: signUpData.phoneNo,
      password: signUpData.password,
      email: signUpData.email,
    });
  }

  public static ForgotPasswordAPI(body: ForgotPasswordBody) {
    return axios.post(FORGOT_PASSWORD_URL, {
      ...body,
    });
  }

  public static ResetPasswordAPI(token: string, body: ResetPasswordBody) {
    return axios.post(`${RESET_PASSWORD_URL}/${token}`, {
      ...body,
    });
  }

  // public static async AuthSignUpBPJS(signUpData: SignUpType) {
  //   await this.SignUpAPI(signUpData).then(async (response) => {
  //     console.log("success", response.data);
  //     const loginData = {
  //       nik: signUpData.nik,
  //       password: signUpData.password,
  //     };
  //     await this.LoginApi(loginData)
  //       .then(async (loginResponse) => {
  //         const token = loginResponse?.data?.data?.accessToken;
  //         await auth.setAuthLocal(token);
  //       })
  //       .catch((error: any) => {
  //       setLoading(false);
  //       console.log("error", error.response);
  //       const { message } = error.response.data;

  //       // Handle API error
  //       if (axios.isAxiosError(error) && error.response) {
  //         // You can display an error message to the user here
  //         console.error("API error:", message);
  //         window.alert(message);
  //       } else {
  //         console.error("Other error:", error);
  //         window.alert(message);
  //         // You can display an error message to the user here
  //       };
  //   }).catch((error: any) => {
  //       setLoading(false);
  //       console.log("error", error.response);
  //       const { message } = error.response.data;

  //       // Handle API error
  //       if (axios.isAxiosError(error) && error.response) {
  //         // You can display an error message to the user here
  //         console.error("API error:", message);
  //         window.alert(message);
  //       } else {
  //         console.error("Other error:", error);
  //         window.alert(message);
  //         // You can display an error message to the user here
  //       };
  //      })
  //  }
  // }
}
